import { get } from '@/services/apiService'; // your wrapper for axios.post
import { ref } from 'vue';

export const isImpersonating = ref(false);

export function revertToSuperUser() {
    const superUser = JSON.parse(localStorage.getItem('superUser'));
    if (!superUser) return;

    // Restore softToken
    const token = superUser.softToken || null;
    if (token) {
        localStorage.setItem('bearer-jwt', token);
        localStorage.setItem('softToken', token);
        localStorage.setItem('hardToken', superUser.hardToken);
    }

    // Restore user info
    localStorage.setItem('username', superUser.username);
    window.vueApp.config.globalProperties.$user.value = superUser;
    isImpersonating.value = false;
    sessionStorage.removeItem('impersonating');
    localStorage.removeItem('superUser');
    window.vueApp.config.globalProperties.$router.push({ name: 'backoffice.shops' });
}

async function fetchMe() {
    // const softToken = localStorage.getItem("softToken");
    const hardToken = localStorage.getItem("hardToken");
    const softToken = localStorage.getItem("softToken");
    const username = localStorage.getItem("username");
    console.log("fetchMe TOKEN", softToken)
    try {
        const response = await get("/account/user", {
            headers: {
                // 'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-USER': username,
                'X-Auth-SOFTTOKEN': softToken,
            },
        })
        console.log("fetchMe", response)
        return response.data.data;
    } catch (err) {
        console.error('fetchMe failed:', err);
        alert('Could not fetchMe.');
    }

}

export async function impersonateUser(entity) {
    try {
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");
        // Call the impersonation API
        const response = await get(`/backoffice/user/login?id=${entity.user.id}`,
            {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                },
            },);

        const newSoftToken = response.data.data.token;
        // const { newHardToken, newSoftToken } = response.data.data;
        console.log("response newSoftToken", response)
        console.log("newSoftToken", newSoftToken)
        const newUser = {
            username: entity.user.username,
            email: entity.user.email,
            softToken: newSoftToken,
            hardToken: null,
            roles: entity.user.roles || [],
            shopData: entity.user.shopData || null
        };

        // Save previous user as superUser
        const currentUser = window.vueApp?.config?.globalProperties?.$user?.value;
        currentUser.hardToken = hardToken;
        currentUser.softToken = softToken;
        console.log("currentUser", currentUser)
        if (currentUser) {
            localStorage.setItem('superUser', JSON.stringify(currentUser));
        }

        // Save impersonated user's token & info
        localStorage.setItem('bearer-jwt', newSoftToken);
        localStorage.setItem('username', newUser.username);

        localStorage.setItem('softToken', newSoftToken);

        // Clear hard token to avoid conflicts
        localStorage.removeItem('hardToken');
        // Update global user reference
        if (window.vueApp?.config?.globalProperties?.$user) {
            window.vueApp.config.globalProperties.$user.value = await fetchMe();
        }
        isImpersonating.value = true;
        sessionStorage.setItem('impersonating', 'true');
        // Redirect to their profile
        // const lang = localStorage.getItem('selectedLanguage')?.toUpperCase() || 'EN';
        window.vueApp.config.globalProperties.$router.push({ name: 'shopHome' });
    } catch (err) {
        console.error('Impersonation failed:', err);
        alert('Could not impersonate user.');
    }
}

export function checkLoggedIn() {
    const hardToken = localStorage.getItem("hardToken");
    // const softToken = localStorage.getItem("bearer-jwt");
    const softToken = localStorage.getItem("softToken");
    if(isImpersonating.value && !!softToken){
        return (isImpersonating.value && !!softToken)
    }
    
    return !!hardToken ; // Return true if the hard token exists // || (isImpersonating.value && !!softToken)
}

export function resetAuthorization() {
    localStorage.removeItem("hardToken");
    localStorage.removeItem("username");
    sessionStorage.removeItem("softToken");
    this.$user.value = null;
}

export function getUser() {
    return window.vueApp?.config?.globalProperties?.$user?.value || null;
}

export function hasRole(role) {
    const user = getUser();

    return user?.roles?.includes(role);
}

export function getPublicityState() {
    const user = getUser();
    return user?.shopData?.publicityState;
}